import React from 'react'
import 'react-vis/dist/style.css'
import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN9020', nightvision: 25, megapixel: 2, power: 16, focal: 2.8, irleds: 6 },
  { name: 'IN7011', nightvision: 12, megapixel: 1, power: 8, focal: 6, irleds: 22 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focal', domain: [2, 6] },
              { name: 'megapixel', domain: [0, 2] },
              { name: 'power', domain: [7, 16] },
              { name: 'nightvision', domain: [11, 25] },
              { name: 'irleds', domain: [5, 22] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}